import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/sites/$siteSlug/content-types/tables/$typeSlug')({
  component: TypeSlugLayout,
});

function TypeSlugLayout() {
  return <Outlet />;
}
